import { useContext } from "react";
import { ProductContext } from "./GetProductContext";

export default function useProductsHook() {
  return useContext(ProductContext);
}
